import { Link } from "react-router-dom";
import type { Video } from "@/types/video";

interface RelatedListProps {
  items: Video[];
}

export default function RelatedList({ items }: RelatedListProps) {
  if (items.length === 0) return null;

  return (
    <section className="mt-10">
      <div className="mb-5 flex items-center gap-2">
        <span className="h-5 w-1 rounded-full bg-primary-500"></span>
        <h2 className="font-heading text-lg font-bold text-foreground-950">相关推荐</h2>
        <span className="text-xs text-foreground-500">基于类型与标签推荐</span>
      </div>

      {/* mobile: horizontal scroll */}
      <div className="no-scrollbar -mx-4 flex gap-4 overflow-x-auto px-4 pb-2 md:hidden">
        {items.map((video) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="w-32 flex-none overflow-hidden rounded-lg border border-background-200/70 bg-background-100"
          >
            <div className="aspect-[2/3] w-full overflow-hidden bg-background-200">
              <img
                src={video.cover}
                alt={`${video.title} 封面`}
                title={`${video.title} 在线观看`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="p-2">
              <h3 className="truncate text-xs font-medium text-foreground-900">{video.title}</h3>
              <p className="mt-1 text-[10px] text-foreground-500">
                {video.type} · {video.year}
              </p>
            </div>
          </Link>
        ))}
      </div>

      {/* desktop: grid */}
      <div className="hidden grid-cols-3 gap-5 lg:grid lg:grid-cols-6">
        {items.map((video) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition hover:border-primary-400/70"
          >
            <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
              <img
                src={video.cover}
                alt={`${video.title} 封面`}
                title={`${video.title} 在线观看`}
                className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
              />
              <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-black/60 px-2 py-0.5 text-[11px] text-accent-400">
                <i className="ri-star-fill text-[10px]"></i>
                {video.rating.toFixed(1)}
              </span>
            </div>
            <div className="p-3">
              <h3 className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-400">
                {video.title}
              </h3>
              <p className="mt-1 text-[11px] text-foreground-500">
                {video.type} · {video.year}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}